export default __webpack_public_path__ + "static/Save-Win-053f3a6d9d5589c783cb5d27c73919e6.webp";